import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 60 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

const ServiceRow = ({ s, i }) => (
  <motion.div
    variants={reveal}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    data-testid={`service-${s.id}`}
    className="group relative grid grid-cols-1 lg:grid-cols-12 items-center gap-6 border-t border-brand-border py-8 lg:py-10 cursor-default"
  >
    <span className="lg:col-span-1 font-anton text-brand-red text-3xl lg:text-2xl">{s.num}</span>

    <div className="lg:col-span-4">
      <h3 className="font-anton uppercase text-3xl lg:text-4xl leading-none tracking-tight group-hover:text-brand-red transition-colors duration-300">
        {s.title}
      </h3>
      <span className="font-outfit text-xs uppercase tracking-[0.25em] text-neutral-500 mt-2 block">{s.tag}</span>
    </div>

    <p className="lg:col-span-5 font-manrope font-light text-neutral-400 leading-relaxed max-w-xl">{s.desc}</p>

    <div className="lg:col-span-2 flex lg:justify-end">
      <ArrowUpRight size={40} weight="light" className="text-neutral-600 group-hover:text-brand-red group-hover:rotate-45 transition-all duration-300" />
    </div>
  </motion.div>
);

export const Services = () => {
  return (
    <section id="servizi" className="relative bg-brand-dark py-24 lg:py-36" data-testid="services-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <p className="font-outfit text-xs tracking-[0.3em] uppercase text-brand-red font-bold mb-4">— I nostri servizi</p>
            <h2 className="font-anton uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight max-w-2xl">
              Cosa possiamo<br />rivestire per te
            </h2>
          </div>
          <p className="font-manrope font-light text-neutral-400 max-w-sm lg:text-right">
            Sei discipline, un solo standard: l'eccellenza. Dal veicolo alla vetrina, diamo forma alla tua immagine.
          </p>
        </div>

        <div>
          {SERVICES.map((s, i) => (
            <ServiceRow key={s.id} s={s} i={i} />
          ))}
          <div className="border-t border-brand-border" />
        </div>
      </div>
    </section>
  );
};
